import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Navigate, useNavigate, useParams } from 'react-router-dom';
import CardProductDetails from './card-product-details';
const CardProductDetailsPage = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const productId = id != null && id !== '' ? Number(id) : NaN;
    if (Number.isNaN(productId) || productId < 1) {
        return _jsx(Navigate, { to: "..", replace: true });
    }
    return (_jsx(CardProductDetails, { productId: productId, onClose: () => navigate('..'), isPageView: true }));
};
export default CardProductDetailsPage;
